import { registerType } from '../types'

export interface CheckboxInterface {
  id: string
  name: string
  text?: string
  value?: string
  errorMessage?: string
  defaultChecked?: boolean
  register: Function
  registerOptions?: registerType
}

export function Checkbox({
  text,
  value,
  errorMessage,
  id,
  name,
  defaultChecked,
  register,
  registerOptions
}: CheckboxInterface) {
  return (
    <>
    <label className="label-secondary my-12">
        <input 
          className="check-primary"
          id={id}
          name={name}
          value={value ?? name}
          {...register(name, registerOptions)}
          defaultChecked={defaultChecked}
        />
        <span>{text ?? name}</span>
    </label>
      {errorMessage && (
        <div
          className="field-validation-error wc-assist wc-assist__bottom wc-assist--error"
          role="alert"
          aria-live="polite"
        >
          {errorMessage}
        </div>
      )}
    </>
  )
}
